<div class="container max-w-screen-xl">
    <div v-if="isLoading" class="grid text-center">
        <p class="text-center">Loading your favorites...</p>
    </div>

    <div v-else class="relative">
        <div v-if="paginatedFavourites.length">
            <div :class="showMap ? 'mb-1.5' : 'mb-0'" class="flex flex-col gap-half lg:flex-row lg:justify-between print:hidden">
                <p class="mb-0 text-center lg:text-left text-secondary">Showing <strong>{{ startingItemPositionOnPage }}</strong>-<strong>{{ endingItemPositionOnPage }}</strong> of <strong>{{ favItems.length }}</strong> result{{ favItems.length > 1 ? 's' : '' }}.</p>
                <div class="flex justify-center lg:justify-normal gap-1 lg:gap-1.5">
                    <button @click="removeAllFavourites" class="text-warning font-bold flex items-center gap-qtr">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-1.5 h-1.5 text-warning">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                        Clear <span class="hidden lg:inline">Favorites</span>
                    </button>
                    <button class="text-primary font-bold flex items-center gap-qtr" v-on:click="toggleMap" v-if="hasListings">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-1.5 h-1.5 text-primary">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z" />
                        </svg>
                        <span>{{ showMap ? 'Hide' : 'Show' }}</span> Map
                    </button>
                </div>
            </div>

            <FavouritesMap
                v-if="hasListings"
                :favourites="paginatedFavourites"
                :showMap="showMap"
            />

            <ul class="basis-full grid mb-3 sm:grid-cols-[repeat(auto-fill,_minmax(424px,_1fr))] gap-x-2 gap-y-1 grid-view">
                <li
                    v-for="item in paginatedFavourites"
                    :key="item.favId"
                    class="relative typography group"
                >
                    <div class="relative">
                        <img
                            v-if="item.imageURL"
                            :src="item.imageURL"
                            alt=""
                            width="600"
                            height="400"
                            class="w-full object-cover aspect-[3/2] mb-1"
                            loading="lazy"
                        />
                        <img
                            v-else
                            src="../assets/no-image.webp"
                            alt=""
                            width="600"
                            height="400"
                            class="w-full object-cover aspect-[3/2] mb-1"
                            loading="lazy"
                        />

                        <div class="absolute -bottom-1.25 right-1 z-10">
                            <favourite-icon
                                :type="item.type"
                                :id="item.id"
                                :isRemoveBtn="true"
                                :cssClasses="removeFavBtnClasses"
                            />
                        </div>
                    </div>
                    <h3 class="text-base mb-0 h5 pr-4 group-hover:text-primary">
                        {{ item.title }}
                    </h3>
                    <p v-if="item.city || item.date" class="text-sm mt-half mb-0">
                        <span v-if="!item.isEvent && item.city" class=" text-mediumgray">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-primary w-1.5 h-1.5 inline mr-qtr">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                            </svg>
                            {{ item.city }}
                        </span>
                        <span v-if="item.isEvent" class="text-mediumgray">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-primary w-1.5 h-1.5 inline mr-qtr">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                            </svg>
                            <span v-if="item.city">
                                {{ item.city }}
                            </span>

                            <span v-if="item.date">
                                &#149; {{ item.date }}
                                <span class="text-primary text-nowrap ml-half font-bold text-xs bg-primary-lighter rounded py-[3px] px-[5px]" v-if="item.hasMoreDates">
                                    Additional Dates
                                </span>
                            </span>
                        </span>
                    </p>
                    <p v-if="item.summary" class="text-sm mt-half mb-0 text-lightgray">
                        {{ item.summary }}
                    </p>
                    <a
                            :href="item.link"
                            class="absolute inset-0"
                    >
                        <span class="sr-only">Read more</span>
                    </a>
                </li>
            </ul>
            <!-- Pagination controls -->
            <nav v-if="isPaginated" class="pagination mt-2 lg:mt-2.5" role="navigation" aria-label="Pagination Navigation">
                <ul class="flex items-center justify-center">
                    <li v-if="currentPage - 1 > 0" class="ml-qtr mr-qtr">
                        <button @click="previousPage" class="button hollow" aria-label="Previous page">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-1.5 h-1.5 stroke-2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                            </svg>
                            <span class="sr-only">Prev</span>
                        </button>
                    </li>
                    <li v-for="pageNumber in totalPageNumbers" :key="pageNumber">
                        <button
                            @click="goToPage(pageNumber)"
                            :class="[currentPage !== pageNumber ? 'button hollow hidden sm:list-item' : 'button']"
                            class="ml-qtr mr-qtr"
                            :aria-label="'Page ' + pageNumber"
                            :aria-current="currentPage === pageNumber ? true : false"
                            :disabled="currentPage === pageNumber"
                        >
                            <span>{{ pageNumber }}</span>
                        </button>
                    </li>
                    <li v-if="currentPage + 1 <= totalPages" class="ml-qtr mr-qtr">
                        <button @click="nextPage" class="button hollow" aria-label="Next page">
                            <span class="sr-only">Next</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-1.5 h-1.5 stroke-2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                            </svg>
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
        <div v-else class="relative text-center">
            <p class="text-center">You don't have any favorites added yet.</p>
        </div>
    </div>
</div>
